module.exports = __webpack_public_path__ + "assets/Hand-holding-dollar.ed2eab29.svg";